import './footer.component.css'

const FooterComponent = () => {
    return (
        <div className="footer">Iscrizioni Danza Jess ©2025 Created by A.P.S.
            Soluzioni Software srl</div>
    )
}

export default FooterComponent